import { defineMessages } from 'react-intl';

export default defineMessages({
    viewInvoices: {
        id: 'billing.billing-summary.View Invoices',
        defaultMessage: 'View Invoices'
    },
    makeAPayment: {
        id: 'billing.billing-summary.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    viewPolicies: {
        id: 'billing.billing-summary.View Policies',
        defaultMessage: 'View Policies'
    },
    changePaymentPlan: {
        id: 'billing.billing-summary.Change Payment Plan',
        defaultMessage: 'Change Payment Plan'
    },
    selectInvoicesToPay: {
        id: 'billing.billing-summary.Select Invoices to Pay',
        defaultMessage: 'Select Invoices to Pay'
    },
    cancelledPolicy: {
        id: 'tdic.billing.billing-summanry.view.Please contact your agent if you want to change your payment plan or bank account details for this policy.',
        defaultMessage: 'Please contact your agent if you want to change your payment plan or bank account details for this policy.'
    },
    policies: {
        id: 'billing.billing-summary.Policies',
        defaultMessage: 'Policies'
    },
    personalAutoPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Personal Auto Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Personal Auto Policy {policyNumber} (Automatic Payments Enabled)'
    },
    personalAutoPolicy: {
        id: 'billing.billing-summary.Personal Auto Policy',
        defaultMessage: 'Personal Auto Policy'
    },
    homeownersPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Homeowners Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Homeowners Policy {policyNumber} (Automatic Payments Enabled)'
    },
    homeownersPolicy: {
        id: 'billing.billing-summary.Homeowners Policy',
        defaultMessage: 'Homeowners Policy'
    },
    businessOwnersPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Business Owners Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Business Owners Policy {policyNumber} (Automatic Payments Enabled)'
    },
    businessOwnersPolicy: {
        id: 'billing.billing-summary.Business Owners Policy',
        defaultMessage: 'Business Owners Policy {policyNumber}'
    },
    commercialAutoPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Commercial Auto Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Commercial Auto Policy {policyNumber} (Automatic Payments Enabled)'
    },
    commercialAutoPolicy: {
        id: 'billing.billing-summary.Commercial Auto Policy',
        defaultMessage: 'Commercial Auto Policy'
    },
    commercialPropertyPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Commercial Property Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Commercial Property Policy {policyNumber} (Automatic Payments Enabled)'
    },
    commercialPropertyPolicy: {
        id: 'billing.billing-summary.Commercial Property Policy',
        defaultMessage: 'Commercial Property Policy'
    },
    commercialPackagePolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Commercial Package Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Commercial Package Policy {policyNumber} (Automatic Payments Enabled)'
    },
    commercialPackagePolicy: {
        id: 'billing.billing-summary.Commercial Package Policy {policyNumber}',
        defaultMessage: 'Commercial Package Policy'
    },
    generalLiabilityPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.General Liability Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'General Liability Policy {policyNumber} (Automatic Payments Enabled)'
    },
    generalLiabilityPolicy: {
        id: 'billing.billing-summary.General Liability Policy {policyNumber}',
        defaultMessage: 'General Liability Policy {policyNumber}'
    },
    inlandMarinePolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Inland Marine Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Inland Marine Policy {policyNumber} (Automatic Payments Enabled)'
    },
    inlandMarinePolicy: {
        id: 'billing.billing-summary.Inland Marine Policy {policyNumber}',
        defaultMessage: 'Inland Marine Policy {policyNumber}'
    },
    workersCompPolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Workers Compensation Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Workers Compensation Policy {policyNumber} (Automatic Payments Enabled)'
    },
    workersCompPolicy: {
        id: 'billing.billing-summary.Workers Compensation Policy {policyNumber}',
        defaultMessage: 'Workers Compensation Policy {policyNumber}'
    },
    workersComp7PolicyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Workers Compensation Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Workers Compensation Policy {policyNumber} (Automatic Payments Enabled)'
    },
    workersComp7Policy: {
        id: 'billing.billing-summary.Workers Compensation Policy {policyNumber}',
        defaultMessage: 'Workers Compensation Policy {policyNumber}'
    },
    policyAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Policy {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Policy {policyNumber} (Automatic Payments Enabled)'
    },
    policy: {
        id: 'billing.billing-summary.Policy',
        defaultMessage: 'Policy'
    },
    ok: {
        id: 'billing.billing-summary.OK',
        defaultMessage: 'OK'
    },
    invoicesAutomaticPaymentsEnabled: {
        id: 'billing.billing-summary.Invoices {policyNumber} (Automatic Payments Enabled)',
        defaultMessage: 'Invoices {policyNumber} (Automatic Payments Enabled)'
    },
    paymentSchedule: {
        id: 'billing.billing-summary.Payment Schedule',
        defaultMessage: 'Payment Schedule'
    },
    startingDate: {
        id: 'billing.billing-summary.Starting Date',
        defaultMessage: 'Invoices Dated On or After'
    },
    changeAutopayBankAccount: {
        id: 'billing.billing-summary.Change Autopay Bank Account',
        defaultMessage: 'Change Autopay Bank Account'
    },
    paymentMethodHasBeenChanged: {
        id: 'billing.billing-summary.Payment method has been changed.',
        defaultMessage: 'Your Autopay bank account change has been successfully updated and will be reflected on your next bank account withdrawal scheduled on or about the 20th of each month.'
    },
    automaticPaymentOfHasBeenAppliedToYourAccount: {
        id: 'billing.billing-summary.Thank you for enrolling in Autopay.',
        defaultMessage: 'Thank you for enrolling in Autopay. Your payment method for policy {policyNumber} has been successfully updated to {paymentData}. Your new payment plan will be reflected on your monthly invoice each 1st of the month. Withdrawals from your bank account will be on or about the 20th of each month.\nTo save paper, monthly invoices will be sent as electronic-only documents.'
    },
    semiAnnualAcknowledgementMessage: {
        id: 'billing.billing-summary.Semi Annual Acknowledgement',
        defaultMessage: 'Your payment method for policy  {policyNumber}  has been successfully updated to {paymentData}. Your new payment plan will be reflected on your next invoice.'
    },
    annualAcknowledgementMessage: {
        id: 'billing.billing-summary.Annual Acknowledgement',
        defaultMessage: 'Your payment method for policy  {policyNumber}  has been successfully updated to Annual (1 Pay). Your new payment plan will be reflected on your next invoice.'
    },
    yourAutomaticPaymentsWillBeginOn: {
        id: 'billing.billing-summary.Your automatic payments will begin on x.',
        defaultMessage: 'Your automatic payments will begin on {startingDate}.'
    },
    paymentOfHasBeenAppliedToYourAccount: {
        id: 'billing.billing-summary.Payment of x has been applied to your account.',
        defaultMessage: 'Payment of {paidAmount} has been applied to your account.'
    },
    amountToPay: {
        id: 'tdic.billing.billing-summary.Invoice Subtotal',
        defaultMessage: 'Invoice Subtotal'
    },
    paymentRequestFailed: {
        id: 'billing.billing-summary.Payment request failed',
        defaultMessage: 'Payment request failed'
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id: 'billing.billing-summary.Sorry your payment could not be processed at this time',
        defaultMessage: 'Sorry your payment could not be processed at this time'
    },
    accountUpdateFailed: {
        id: 'billing.billing-summary.Account update failed',
        defaultMessage: 'Account update failed'
    },
    sorryWeWereNotAbleToSetupAutomaticPaymentsOnYourAccount: {
        id: 'billing.billing-summary.Sorry, we were not able to setup automatic payments on your account',
        defaultMessage: 'Sorry, we were not able to setup automatic payments on your account'
    },
    changingPaymentMethod: {
        id: 'billing.billing-summary.Changing payment method',
        defaultMessage: 'Changing payment method'
    },
    thereWasAProblemChangingThePaymentMethod: {
        id: 'billing.billing-summary.There was a problem changing the payment method',
        defaultMessage: 'There was a problem changing the payment method'
    },
    invoicesToPay: {
        id: 'billing.billing-summary.Invoices to Pay',
        defaultMessage: 'Invoices to Pay'
    },
    paidInvoices: {
        id: 'billing.billing-summary.Closed Invoices',
        defaultMessage: 'Closed Invoices'
    },
    creditCardFee: {
        id: 'tdic.billing.billing-summary.Credit card fee',
        defaultMessage: 'Credit card fee'
    },
    grandTotal: {
        id: 'tdic.billing.billing-summary.Total Payment',
        defaultMessage: 'Total Payment'
    },
    confirmEmailAddress: {
        id: 'tdic.billing.billing-summary.Confirmation Email Address',
        defaultMessage: 'Confirmation Email Address'
    },
    name: {
        id: 'tdic.billing.billing-summary.billing-documents.Name',
        defaultMessage: 'Name'
    },
    dateCreated: {
        id: 'tdic.billing.billing-summary.billing-documents.Date Created',
        defaultMessage: 'Date Created'
    },
    documentType: {
        id: 'tdic.billing.billing-summary.billing-documents.Document Type',
        defaultMessage: 'Document Type'
    },
    viewDownload: {
        id: 'tdic.billing.billing-summary.billing-documents.View/Download',
        defaultMessage: 'View/Download'
    },
    tncBilling: {
        id: 'tdic.billing.billing-summary.billing-documents.By making your payment, you agree to {tncLink}',
        defaultMessage: 'By making your payment, you agree to {tncLink}'
    },
    downloadErrorMessage: {
        id: 'tdic.billing.billing-summary.billing-documents.Apologies: we are unable to access your billing documents at this time. Please try again later.',
        defaultMessage: 'Apologies: we are unable to access your billing documents at this time. Please try again later.'
    },
    billingDocText: {
        id: 'tdic.billing.billing-summary.The following documents were generated by TDIC for you to download, save and print at your convenience on desktop, laptop and tablet devices. Contact your agent if you have any questions or don\'t see what you are looking for.',
        defaultMessage: 'The following documents were generated by TDIC for you to download, save and print at your convenience on desktop, laptop and tablet devices. Contact your agent if you have any questions or don\'t see what you are looking for.'
    },
    billingNoDocText: {
        id: 'tdic.billing.billing-summary.No documents found.',
        defaultMessage: 'No documents found.'
    },
    paymentPlanRequestFailed: {
        id: 'tdic.billing.billing-summary.ERROR',
        defaultMessage: 'ERROR'
    },
    UnableToChangeThePaymentPlan: {
        id: 'tdic.billing.billing-summary.Sorry we can not change the payment plan at this time',
        defaultMessage: 'Sorry we can not change the payment plan at this time'
    },
    payMyBill: {
        id: 'tdic.billing.billing-summary.Pay My Bill',
        defaultMessage: 'Pay My Bill'
    },
    payment: {
        id: 'tdic.billing.billing-summary.Monthly Autopay',
        defaultMessage: 'Monthly Autopay'
    },
    automaticPaymentsEnabled: {
        id: 'tdic.billing.billing-summary.Automatic Payments Enabled',
        defaultMessage: '(Automatic Payments Enabled)'
    },
    equityPercentageMsg: {
        id: 'tdic.billing.billing-summary.Please select to pay your past due invoice. Please allow 1-2 business days for payment processing. After your payment is received, you will be able to return to this page to manage your payment plan for this policy.',
        defaultMessage: 'Please select {link} to pay your past due invoice. Please allow 1-2 business days for payment processing. After your payment is received, you will be able to return to this page to manage your payment plan for this policy.'
    },
    payMyBillLink: {
        id: 'tdic.billing.billing-summary.Pay My Bill',
        defaultMessage: 'Pay My Bill'
    },
    automaticPaymentPlan: {
        id: 'tdic.billing.billing-summary.automatic-12-pay',
        defaultMessage: 'Thank you for enrolling in Autopay. Your payment method for policy {policyNumber} has been successfully updated to {paymentData}. Your new payment plan will be reflected on your monthly invoice each 1st of the month. Withdrawals from your bank account will be on or about the 20th of each month. To save paper, monthly invoices will be sent as electronic-only documents.'
    },
});
